import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { EmployerModel } from 'src/app/model/employer.model';
import { PreviousContributionModel } from 'src/app/model/previous-contribution.model';

export const RequestAction = createAction('[Previous Contributions view overview] get data', props<{ page: number }>());
export const ResponseAction = createAction('[Previous Contributions view overview] set data',  props<{ payload: PreviousContributionModel[] }>());
export const LoadMoreAction = createAction('[Previous Contributions view overview] load more');
